export default __webpack_public_path__ + "static/media/Tekken.67ec3323.jpg";